import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function SavePlayList(props) {

  const [playListName, setPlayListName] = useState("");

  useEffect(() => { 
    setPlayListName("");
  }, [props.open])

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onPlayListSave(playListName);
    }
  };

  return (
    <BDialog openToLeft={props.openToLeft} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_create_new_playlist}</DialogTitle>
      <DialogContent>
        <InputLabel>{TR.cm_name}</InputLabel>
        <TextField
          autoFocus
          margin="dense"
          type="text"
          fullWidth
          onChange={(e) => setPlayListName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onPlayListSave(playListName)}>{TR.cm_create}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SavePlayList;